// export const API_BASE_URL = 'https://xenon.gbmsoft.com/whatsappBusinnesWater'
// export const API_BASE_URL = 'http://localhost:9528'
// export const API_BASE_URL = 'https://localhost:7174' // Yeni Servis
//export const API_BASE_URL ="https://xenon.gbmsoft.com/WhatsappApiWatterOrderDubai"; // Su Siparişi
// export const API_BASE_URL ="https://xenon.gbmsoft.com/whatsappBusinnesApiBooking"; // Otel rezervasyon
// export const API_BASE_URL = 'http://localhost:5248' // Otel rezervasyon
//export const API_BASE_URL ="https://xenon.gbmsoft.com/whatsappBusinessDemo"
export const API_BASE_URL ="https://admin.chatshire.io/chatshireadminservice"
// export const API_BASE_URL = "https://admintest.chatshire.io/chatshireadmintestservice2"
// export const API_BASE_URL ="http://admintest2.chatshire.io/chatshireadmintestservice"
// export const API_BASE_URL ="https://localhost:7174"
export const API_EXTRA_PATH = '/api/v1'
export const API_FULL_URL = API_BASE_URL + API_EXTRA_PATH

// ELOGO Payment API Credentials
export const ELOGO_APIKEY = 'cf43cd2b-7d2e-401b-9738-0c3819adf6de'
export const ELOGO_SECRETKEY = '8fc30c60-65d1-456f-b263-a8979cc9d864'

